<div class="container">
  <div class="description" [innerHtml]="this.description"></div>
  <app-card-component *ngFor="let card of cards" [info]="card"></app-card-component>
</div>
